export default (state, action, _ref) => {
  let {
    initialState,
    types
  } = _ref;
  switch (action.type) {
    case types.SET_RECENT_SEARCHES:
      {
        return {
          ...state,
          inventorySearches: action.payload
        };
      }
    case types.SET_RECENT_SEARCHES_INVENTORY:
      {
        return {
          ...state,
          recentlySearchedWithListings: action.payload
        };
      }
    default:
      return state;
  }
};